module.exports = __webpack_public_path__ + "static/img/user-comment2.eef305e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/user-comment2.png
// module id = YynF
// module chunks = 0